import _defineProperty from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["aria-label", "icon", "selected", "sx"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React__default from 'react';
import styled from 'styled-components';
import sx from '../sx.js';
import { getSegmentedControlListItemStyles, getSegmentedControlButtonStyles } from './getSegmentedControlStyles.js';
import { defaultSxProp } from '../utils/defaultSxProp.js';
import Box from '../Box/Box.js';
import merge from 'deepmerge';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var SegmentedControlIconButtonStyled = styled.button.withConfig({
  displayName: "SegmentedControlIconButton__SegmentedControlIconButtonStyled",
  componentId: "sc-oxh6a9-0"
})(["", ";"], sx); // TODO: update this component to be accessible when we update the Tooltip component
// - we wouldn't render tooltip content inside a pseudoelement
// - users can pass custom tooltip text in addition to `ariaLabel`
//
// See Slack thread: https://github.slack.com/archives/C02NUUQ9C30/p1656444474509599
//

var SegmentedControlIconButton = function SegmentedControlIconButton(_ref) {
  var ariaLabel = _ref['aria-label'],
      Icon = _ref.icon,
      selected = _ref.selected,
      _ref$sx = _ref.sx,
      sxProp = _ref$sx === void 0 ? defaultSxProp : _ref$sx,
      rest = _objectWithoutProperties(_ref, _excluded);

  var mergedSx = merge(_objectSpread({
    width: '32px'
  }, getSegmentedControlListItemStyles()), sxProp);
  return /*#__PURE__*/React__default.createElement(Box, {
    as: "li",
    sx: mergedSx
  }, /*#__PURE__*/React__default.createElement(SegmentedControlIconButtonStyled, _extends({
    "aria-label": ariaLabel,
    "aria-current": selected,
    sx: getSegmentedControlButtonStyles({
      selected: selected,
      isIconOnly: true
    })
  }, rest), /*#__PURE__*/React__default.createElement("span", {
    className: "segmentedControl-content"
  }, /*#__PURE__*/React__default.createElement(Icon, null))));
};

SegmentedControlIconButton.displayName = "SegmentedControlIconButton";
var SegmentedControlIconButton$1 = SegmentedControlIconButton;
export { SegmentedControlIconButton, SegmentedControlIconButton$1 as default };